import React from 'react';
import { Clock, Settings, CheckCircle2 } from 'lucide-react';

const DeploymentSection = () => {
  const steps = [
    'Install repeaters on walls and strategic locations',
    'Attach BLE tags to your returnable assets',
    'Configure dashboard and set up alerts',
    'Start tracking in real-time',
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-50 rounded-full mb-4">
            <Clock className="w-5 h-5 text-green-600" />
            <span className="text-green-600 font-semibold text-sm">Fast Deployment</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Deploy in 24 Hours
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Simple installation, no complex IT infrastructure required
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-900 to-blue-700 flex items-center justify-center flex-shrink-0 text-white font-bold text-lg">
                  {index + 1}
                </div>
                <div className="flex-1">
                  <p className="text-lg text-gray-700 font-medium pt-2">{step}</p>
                </div>
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-2" />
              </div>
            ))}
          </div>

          <div className="grid grid-cols-2 gap-4">
            <img 
              src="https://images.unsplash.com/photo-1732247429548-ede5fbfee3f0"
              alt="Repeater installation"
              className="rounded-xl shadow-lg w-full h-48 object-cover"
            />
            <img 
              src="https://images.unsplash.com/photo-1650809652009-6e2789d3bab6"
              alt="BLE tags"
              className="rounded-xl shadow-lg w-full h-48 object-cover"
            />
            <img 
              src="https://images.unsplash.com/photo-1734510722516-5a558dc910d2"
              alt="Tagged crates"
              className="rounded-xl shadow-lg w-full h-48 object-cover col-span-2"
            />
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-50 to-red-50 rounded-2xl p-8 border border-gray-200">
          <div className="flex items-start gap-4">
            <Settings className="w-8 h-8 text-blue-900 flex-shrink-0" />
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">Plug-and-Play Simplicity</h3>
              <p className="text-gray-700 leading-relaxed">
                E2-Return is designed for rapid deployment. No specialized training, no complex network configuration, no expensive consultants. Just mount, tag, and track.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DeploymentSection;
